import { jsx as _jsx } from "react/jsx-runtime";
import VibeBanner from "../vibe/banner/index.js";
import { ADDONS } from "constants/addons";
const AddonBanner = ({ addon, selectedUnit, onUnitChange, period })=>{
    if (!addon) {
        return null;
    }
    if (addon === ADDONS.VIBE) {
        return /*#__PURE__*/ _jsx(VibeBanner, {
            addon: addon,
            selectedUnit: selectedUnit,
            onUnitChange: onUnitChange,
            period: period
        });
    }
    return null;
};
export default AddonBanner;
